<template>
  <div>
    <v-autocomplete
        dense
        :items="selectableItems"
        item-text="address"
        label="Select Mailbox"
        hide-details
        solo
        return-object
        ref="principleSelector"
        v-model="refValueChanged"
    >
      <template slot="selection" slot-scope="item">
                        <v-layout row align-center class="hide-parent pl-2">
                            <v-flex shrink class="pr-2">
                                <img src="../../../../../public/zohoLogo.svg" height="24px">
                            </v-flex>
                            <v-flex xs12 class="body-2">
                                {{item.item.address}}
                            </v-flex>
                        </v-layout>
      </template>
      <template slot="item" slot-scope="address">
        <v-layout row align-center class="hide-parent">
          <v-flex shrink class="pr-2">
            <img src="../../../../../public/zohoLogo.svg" height="24px">
          </v-flex>
          <v-flex xs12 class="body-1">
            {{ address.item.address }}
          </v-flex>
          
          <!--                    <v-flex shrink v-if="address.item.type == 'saved'" class="hide-child">-->
          <!--                        <v-tooltip top>-->
          <!--                            <v-btn small icon flat color="red" slot="activator" class="pa-0 ma-0" @click="removePrinciple(address.item.id)">-->
          <!--                                <v-icon>-->
          <!--                                    delete-->
          <!--                                </v-icon>-->
          <!--                            </v-btn>-->
          <!--                            <span>Remove  Mailbox</span>-->
          <!--                        </v-tooltip>-->
          <!--                    </v-flex>-->
        
        </v-layout>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>

import {codeBaseMixin} from "../../../../codeBaseMixin";
import InputDlg from "../../../../components/General/InputDlg";

export default {
  components: {appInputDlg: InputDlg},
  mixins: [codeBaseMixin],
  props: {
    userInfo: Object,
    zohoConfig: Object,
    value: Object,
  },
  data() {
    return {
      savedUserPrinciples: [],
      loadingPrinciples: false,
      showNewMailbox: false,
      newMailboxString: '',
      showAddMailBoxDialog: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.setRefVal(val)
      }
    }
  },
  methods: {
    
    setRefVal(val) {
      if (!val) {
        console.log('HERE')
        let refAddr;
        
        try {
          refAddr = JSON.parse(this.userInfo.defaultSendAsAddress)?.address;
        } catch (e) {
          // console.log(e)
        }
        
        this.$emit('input', this.zohoConfig.addresses.find(addr => addr.address === refAddr) || this.zohoConfig.addresses[0]);
      } else {
        let refAddr = val?.address;
        let refVal = this.zohoConfig.addresses.find(addr => addr.address === refAddr);
        if (refVal !== this.value && this.value !== null) {
          this.$emit('input', refVal);
        }
      }
    }
    
  },
  computed: {
    
    selectableItems() {
      console.log(this.zohoConfig.addresses)
      return this.zohoConfig.addresses.filter(v => v.primary).toSorted((a, b) => a.address.localeCompare(b.address)).concat([{address: 'Add New Mailbox', tokenId: 'new'}]);
    },
    
    refValueChanged: {
      get() {
        return this.value;
      },
      set(val) {
        if (val?.tokenId === 'new') {
          console.log('HERE123')
          this.$emit('newToken', null);
        } else {
          this.$emit('input', val);
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
